import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import React, { useState, useContext } from "react";
import "../../index.css";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { ProductContext } from "../../context/AppContext";
import { Modal } from "react-bootstrap";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import HomeIcon from "@mui/icons-material/Home";
import EditIcon from "@mui/icons-material/Edit";
import FlightTakeoffIcon from "@mui/icons-material/FlightTakeoff";
import Person4Icon from "@mui/icons-material/Person4";
import Footer from '../Common_Components/Footer';

function HiraganaWorksheet() {
  const location = useLocation();
  const navigate = useNavigate();
  const { Translate } = useContext(ProductContext);
  const currentLang = localStorage.getItem("selectedLanguage");
  const isHindi = currentLang === "hindi";

  const [activePage, setActivePage] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState("");

  const images = [
    {
      title: Translate?.message?.data?.HiraganaFilledWorksheet,
      url: isHindi
        ? `${process.env.PUBLIC_URL}/assets/images/material/hiragana-filled-hindi.jpg`
        : `${process.env.PUBLIC_URL}/assets/images/material/filled-hiragana-english.png`,
    },
    {
      title: Translate?.message?.data?.HiraganaTraceableWorksheet,
      url: `${process.env.PUBLIC_URL}/assets/images/material/traceable-hiragana-hindi-and-english.jpeg`,
    },
    {
      title: Translate?.message?.data?.HiraganaEmptyWorksheet,
      url: isHindi
        ? `${process.env.PUBLIC_URL}/assets/images/material/empty-katakana-and-hiragana-hindi.jpg`
        : `${process.env.PUBLIC_URL}/assets/images/material/empty-katakana-and-hiragana-english.jpg`,
    },
  ];

  const openModal = (image) => {
    setSelectedImage(image);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setSelectedImage("");
  };

  const printFile = (fileUrl) => {
    const printWindow = window.open("", "_blank");
    printWindow.document.write(`
      <html>
        <head>
          <title>Print</title>
          <style>
            body { margin: 0; display: flex; justify-content: center; align-items: center; }
            img { max-width: 100%; max-height: 100vh; }
          </style>
        </head>
        <body>
          <img src="${fileUrl}" onload="window.print(); window.close();" />
        </body>
      </html>
    `);
    printWindow.document.close();
  };

  <style>
    {`
          .custom-modal-width .modal-dialog {
            max-width: 80%;
          }
        `}
  </style>;

  return (
    <div className="Profile_Design_Main_Div_11">
      <div className="header_inner">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <ArrowBackIosIcon
                onClick={() => navigate(-1)}
                className="icon_1"
              />
              <h2>{Translate?.message?.data?.HiraganaWorksheet}</h2>
              <ChatBubbleOutlineIcon onClick={() => navigate('/chat-with-staff')} className="logo_1" style={{ cursor: 'pointer', color: '#ffc0cb' }} />
            </div>
          </div>
        </div>
      </div>

      <div className="main-div-section">
        <div className="content-box-day-module">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="daymodule-image">
                  <img
                    src={`${process.env.PUBLIC_URL}/assets/images/learning5.png`}
                    alt="Japan"
                  />
                </div>
                {images.map((img, idx) => (
                  <div className="row">
                    <div className="button-wrapper">
                      <button
                        className="learn-script-content-day-module"
                        onClick={() => openModal(img)}
                      >
                        <div className="module-text-learn-script">
                          <div className="module-text-learn-script22"></div>
                          <h2>{img.title}</h2>
                        </div>
                        <img
                          src={`${process.env.PUBLIC_URL}/assets/images/loading.png`}
                          className="daymodule-icon"
                        />
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      <Modal
        show={showModal}
        onHide={closeModal}
        centered
        dialogClassName="full-width-modal_2"
      >
        <Modal.Header closeButton>
          <Modal.Title>{selectedImage.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center">
          {selectedImage?.url && (
            <img
              src={selectedImage?.url}
              alt={selectedImage?.title}
              style={{ width: "100%", height: "auto", marginBottom: "15px" }}
            />
          )}
          <div className="text-center">
            <button
              className="btn"
              style={{
                width: "30%",
                backgroundColor: "black",
                color: "white",
                padding: "10px",
                fontSize: "16px",
                marginRight: "15px",
              }}
              onClick={() => printFile(selectedImage?.url)}
            >
              Print
            </button>
            <button
              className="btn"
              style={{
                width: "30%",
                backgroundColor: "#ccc",
                color: "#000",
                padding: "10px",
                fontSize: "16px",
              }}
              onClick={closeModal}
            >
              Close
            </button>
          </div>
        </Modal.Body>
      </Modal>
      <Footer />
    </div>
  );
}

export default HiraganaWorksheet;
